export class PoMoUpdateRequest {
    moNumbers: string[];
    masterPoNumber: string;
}